import React from 'react'

class Header extends React.Component {
    render() {
        return (
            <>
                <div className='row'>
                    <div className="col-md-6">
                        <div className="pull-left" ><h3> Containers</h3></div>
                    </div>
                </div>
            </>
        )
    }
}
export default Header